"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AbstractCache_1 = __importDefault(require("./AbstractCache"));
const Observable_1 = __importDefault(require("./Observable"));
class InMemoryCache extends AbstractCache_1.default {
    constructor() {
        super(...arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.values = new Map();
        this.setValue = (key, value) => {
            const o = new Observable_1.default();
            o.setValue(undefined);
            this.values.set(key, JSON.parse(JSON.stringify(value)));
            return o;
        };
        this.getValue = (key) => {
            const o = new Observable_1.default(key);
            const value = this.values.get(key);
            o.setValue(value === undefined ? null : JSON.parse(JSON.stringify(value))); // drop references
            return o;
        };
        this.isEmpty = () => this.values.size === 0;
    }
    clear() {
        this.values = new Map();
        return Promise.resolve();
    }
}
exports.default = InMemoryCache;
//# sourceMappingURL=InMemoryCache.js.map